import React, {Component} from 'react';
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';
import QueryString from 'query-string';

import * as UserActions from '../../../actions/userActions';
import Loader from '../../../components/commons/loader/loader';

class ResetPasswordPage extends Component {

  constructor(props){
    super(props);
    this.state = {
      password1:'',
      password2: '',
      showAlert: false,
      swalParams: {
        title: ""
      }
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {

    const {location} = this.props;
    let params = QueryString.parse(this.props.location.search);

    if(params.token) {
      this.setState({token: params.token});
    }

    window.onkeydown = null;
  }

  render() {

    const {email, showAlert, swalParams} = this.state;
    const {loading} = this.props;

    console.log("RESET_PASSWORD_PAGE_PROPS", this.props);
    console.log("RESET_PASSWORD_PAGE_STATE", this.state);
    return (
      <div className="page reset-password-page">
        <div className="container">
          <h1 className="page-title">Reset Password</h1>
          <div className="row">
            <div className="col-md-6">
              <form onSubmit={this.onSubmit}>
                <input required type="password" aria-label="New Password" className="password-input" onChange={(e)=>this.setState({password1:e.target.value})} placeholder="New Password"/>
              <input required type="password" aria-label="New Password Repeat" className="email-input" onChange={(e)=>this.setState({password2:e.target.value})} placeholder="New Password Repeat"/>
                <button type="submit" className="reset-password-button" >Reset Password</button>
              </form>
            </div>
          </div>
        </div>
        <Loader visibility={loading} />
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }

  onSubmit(e) {
    e.preventDefault();
    let {token, password1, password2} = this.state;

    if(password1 && password2 && password1 === password2){
      this.props.dispatch(UserActions.setNewPassword({token: token, password: password1}, response => {
        console.log("reset password response", response);
        if(response.status) {
          this.setState({showAlert: true, swalParams: {
            title: "Your password has been changed successfully",
            type: "success",
            showConfirmButton: false
          }})
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        } else {
          this.setState({showAlert: true, swalParams: {
            title: "Password reset failed, please try again later!",
            type: "error",
            showConfirmButton: false
          }})
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        }
      }))
    }
  }
}


export default connect((state) => {
  return {
    error: state.getIn(['users', 'error']),
    loading: state.getIn(['users', 'loading'])
  };
})(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/begin/reset-password/ResetPasswordPage.js